module.exports = __webpack_public_path__ + "img/icon-area-scan.4ae60795.svg";